import { DialogModal } from '../../components';
import Breadcrumbs from '../../components/Breadcrumb';
import { metaTitle } from '../../util/tabTitle';
import EventTable from './EventTable';
import { FullCalender } from './FullCalender';
import { PresentationSchedularForm } from './PresentationSchedularForm';
import { Box, Button, Chip, Stack } from '@mui/material';
import { FC, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Calendar, List } from 'react-feather';
import {
  managementControlSx,
  ManagementPageHeader,
  ManagementToolbar,
  RefreshAction,
} from '../../components/ManagementPageLayout';

const EventPage: FC = () => {
  const params = useParams<{ id: string }>();
  metaTitle('Event');
  const [openSchedule, setOpenSchedule] = useState(false);
  const [schedulerId, setSchedulerId] = useState('');
  const [refreshTable, setRefreshTable] = useState(false);
  const [toggle, setToggle] = useState(false);

  const location = useLocation();
  const { state } = location;
  const timeZone = state?.timezone;

  const searchParams = state?.search;
  const schedulerPageUrl = searchParams
    ? `/scheduler${searchParams}`
    : '/scheduler';

  return (
    <Box sx={{ width: '100%', maxWidth: 1360, mx: 'auto' }}>
      <Breadcrumbs
        items={[
          {
            label: 'Schedulers',
            to: schedulerPageUrl,
          },
          {
            label: 'Events',
            to: location?.pathname,
            description:
              'This page showcases the collection of events organized within a specific schedule, highlighting their details and providing functionality for event creation, editing, and deletion. Additionally, the events can be viewed on a calendar interface. It is possible to have multiple events scheduled simultaneously. In such cases, the newly created event will replace any previously scheduled event. The event table presents a comprehensive overview of all events, including their start and end dates, times, and frequency.',
          },
        ]}
      />
      <ManagementPageHeader
        title="Schedule events"
        subtitle="Create and manage the presentation events in this schedule."
        actionLabel="New event"
        onAction={() => {
          setOpenSchedule(true);
          setSchedulerId(params.id || '');
        }}
      />
      <ManagementToolbar>
        <Chip
          label={`Time zone: ${timeZone || 'Not specified'}`}
          sx={{ bgcolor: '#eef2ff', color: '#4338ca', fontWeight: 700 }}
        />
        <Stack direction="row" spacing={1.25} justifyContent="flex-end">
          <Button
            variant="outlined"
            startIcon={toggle ? <List size={16} /> : <Calendar size={16} />}
            onClick={() => setToggle(!toggle)}
            sx={managementControlSx}
          >
            {toggle ? 'List view' : 'Calendar view'}
          </Button>
          <RefreshAction onClick={() => setRefreshTable(!refreshTable)} />
        </Stack>
      </ManagementToolbar>
      {toggle ? (
        <FullCalender refresh={refreshTable} />
      ) : (
        <EventTable refresh={refreshTable} />
      )}
      <DialogModal
        title="Create a new event"
        onClose={() => setOpenSchedule(false)}
        open={openSchedule}
        width={560}
      >
        <PresentationSchedularForm
          onFinished={() => setOpenSchedule(false)}
          schedulerId={schedulerId || ''}
        />
      </DialogModal>
    </Box>
  );
};

export default EventPage;
